import { render, staticRenderFns } from "./Winnerhistory.vue?vue&type=template&id=2333cb71&scoped=true&"
import script from "./Winnerhistory.vue?vue&type=script&lang=js&"
export * from "./Winnerhistory.vue?vue&type=script&lang=js&"
import style0 from "./Winnerhistory.vue?vue&type=style&index=0&id=2333cb71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333cb71",
  null
  
)

export default component.exports